import { useAppSelector } from "../../../utils/hooks";
import TextTranslate from "../../../utils/TextTranslate";

export default function AboutConversation() {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  const isPrivate =
    currentConversationData.chat_type == "private" &&
    !!currentConversationData.bio;
  const isGroup =
    currentConversationData.chat_type == "group" &&
    !!currentConversationData.group_description;

  if (!isPrivate && !isGroup) return null;

  return (
    <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      <div className="px-4 py-3">
        <div className="text-[13px] font-medium uppercase tracking-wide text-lightText">
          <TextTranslate text={isPrivate ? "About" : "Group Description"} />
        </div>
        <div className="mt-1 text-[15px] leading-snug text-darkText">
          {isPrivate
            ? currentConversationData.bio
            : currentConversationData.group_description}
        </div>
      </div>
    </div>
  );
}
